module.exports = __webpack_public_path__ + "static/media/agenda-multiagenda.7f329210.svg";